import React from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkle } from '@fortawesome/pro-solid-svg-icons';

interface Props {
  className?: string;
  onClick?: () => void;
}

export default function SparkBadge({ className, onClick }: Props) {
  return (
    <span
      className={classNames(
        'ai-assistant-spark-badge bg-gradient-ai-decorative d-inline-flex align-items-center'
          + ' justify-content-center rounded-circle',
        className,
      )}
      onClick={onClick}
    >
      <FontAwesomeIcon className="icon-gradient-ai" icon={faSparkle} size="lg" />
    </span>
  );
}
